export default __webpack_public_path__ + "static/Vol 3 - TA 6 - NIA (with appendices)-29edaa4e67911f7fb7a88efb0c9923ef.pdf";